module.exports = __webpack_public_path__ + "img/clouds-white-reverse.ec4e4a6b.png";